import { render, staticRenderFns } from "./EstadoNovedad.vue?vue&type=template&id=48c518c2&scoped=true"
import script from "./EstadoNovedad.vue?vue&type=script&lang=js"
export * from "./EstadoNovedad.vue?vue&type=script&lang=js"
import style0 from "./EstadoNovedad.vue?vue&type=style&index=0&id=48c518c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c518c2",
  null
  
)

export default component.exports